import Cookies from 'js-cookie';
import { axiosProtected, baseUrl } from '../config';

export const getLmaDetails =  async (data) => {
  try {
    const lmaDetails = await axiosProtected.post('/LMA/GetLMASupportDocuments', data);
    return lmaDetails.data
  } catch (e) {    
    return null
  }
}

export const submitLmaDetails =  async (data) => {
    try {
      const lmaDetails = await axiosProtected.post('/LMA/UploadLMADocument', data);
      return lmaDetails.data
    } catch (e) {    
      return null
    }
}

export const deleteDocument =  async (data) => {
  try {
    const lmaDetails = await axiosProtected.post('/LMA/DeleteDocument', data);
    return lmaDetails.data
  } catch (e) {    
    return null
  }
}

export const downloadLmaDocument = async (data) => {
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/LMA/DownloadDocument`,
        method: 'POST',
        responseType: 'blob', 
        data: data
      })
      return res.data
  } catch (e) {      
    return null
  }
}

export const uploadSupportedDocs = async (data) => {
  try {
    const documentDetails = await axiosProtected.post('/LMA/UploadSupportDocument', data);
    return documentDetails.data
  } catch (e) {    
    return null
  }
}

export const deleteSupportedDocument =  async (data) => {
  try {
    const lmaDetails = await axiosProtected.post('/LMA/DeleteSupportDocument', data);
    return lmaDetails.data
  } catch (e) {    
    return null
  }
}

export const downloadSupportedLmaDocument = async (data) => {
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/LMA/DownloadSupportDocument`,
        method: 'POST',
        responseType: 'blob', 
        data: data
      })
      return res.data
  } catch (e) {      
    return null
  }
}

export const downloadLmaPackageDoc = async (data) => {
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/LMA/DownloadPackageDocument`,
        method: 'POST',
        responseType: 'blob', 
        data: data
      })
      return res.data
  } catch (e) {      
    return null
  }
}

export const downloadDocumentByComment = async (data) => {
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/LMA/DownloadDocumentByComment`,
        method: 'POST',
        responseType: 'blob', 
        data: data
      })
      return res.data
  } catch (e) {      
    return null
  }
}

export const submitBorrowerComment = async (data) => {
  try {
      const borrowerResponse = await axiosProtected.post('/LMA/SubmitBorrowerResponse', data);
      return borrowerResponse.data
  } catch (e) {      
    return null
  }
}

export const submitLMARequest =  async (data) => {
  try {
    const lmaSubmitDetails = await axiosProtected.post('/LMA/GetLMAPackage', data);
    return lmaSubmitDetails.data
  } catch (e) {    
    return null
  }
}

export const getSpocDetails =  async (data) => {
  try {
    const lmaSpocDetails = await axiosProtected.post('/LMA/GetSpocDetails', data);
    return lmaSpocDetails.data
  } catch (e) {    
    return null
  }
}

export const getLMARequestDetails =  async (data) => {
  try {
    const requestDetails = await axiosProtected.post('/LMA/RequestDetail', data);
    return requestDetails.data
  } catch (e) {    
    return null
  }
}

export const uploadDocumentInComment =  async (data) => {
  try {
    const requestDetails = await axiosProtected.post('/LMA/UploadAdditionalDocuments', data);
    return requestDetails.data
  } catch (e) {    
    return null
  }
}

export const deleteCommentLmaDocument =  async (data) => {
  try {
    const lmaDetails = await axiosProtected.post('/LMA/DeleteAdditionalDocument', data);
    return lmaDetails.data
  } catch (e) {    
    return null
  }
}

export const downloadCommentLmaDocument = async (data) => {
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/LMA/DownloadAdditionalDocument`,
        method: 'POST',
        responseType: 'blob', 
        data: data
      })
      return res.data
  } catch (e) {      
    return null
  }
}
